import React, { memo } from 'react'
import { Space, Button } from 'antd'
import s from './index.module.scss'
import { PlusOutlined } from '@ant-design/icons'

interface CarouselProps {
  name: string
  onAddClick: (payload) => void
  children?: any
  sectionItem?: any
}

const Carousel: React.FC<CarouselProps> = memo(
  ({ children, sectionItem, onAddClick }) => {
    return (
      <div className={s.carousel}>
        <Space className={s.carouselSpace} align="center">
          {children || <p className={s.noData}>No data</p>}
          <Button
            onClick={() => onAddClick(sectionItem)}
            style={{
              width: 120,
              height: 200,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '10px',
              backgroundColor: '#857f7f',
            }}
          >
            <PlusOutlined />
          </Button>
        </Space>
      </div>
    )
  }
)

Carousel.displayName = 'Carousel'
export default Carousel
